var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"learn-more"},[_c('div',{staticClass:"content is-clickable has-text-centered",class:{leftTable: _vm.moveLeftOnTablet},on:{"click":_vm.scrollTo}},[_c('span',[_vm._v("Learn More")]),_c('br'),_c('chevron-down-icon',{attrs:{"size":"1.2x"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }